import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mantine/hooks";
import { Header } from "./header/Header";
import { Footer } from "./Footer";
import { useThemeSync } from "../lib/useThemeSync";
import { apps } from "../apps/registry";

export function SiteLayout() {
  useThemeSync();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 48em)");
  const slug = location.pathname.match(/^\/apps\/([^/]+)/)?.[1];
  const chromeless = Boolean(
    isMobile && slug && apps.find((a) => a.slug === slug)?.fullscreen
  );

  // React Router doesn't reset scroll on in-app navigation; the browser keeps
  // wherever you were on the previous route. Snap back to top whenever the
  // path actually changes (hash-only changes leave scroll alone so anchors and
  // #demo deep-links still work).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex min-h-dvh flex-col bg-[color:var(--color-bg)] pb-16 text-[color:var(--color-fg)] sm:pb-0">
      <Header />
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
      {!chromeless && <Footer />}
    </div>
  );
}
